import { Application } from '@goodboydigital/astro';
import { Container, Sprite, Texture } from 'pixi.js';
import { Random, RandomSeed, SeededRandom } from '../utils/Random';
import { App } from '../App';

class MenuCloud extends Sprite
{
    public speed = 1;

    constructor()
    {
        super(Texture.from('preload-cloud.png'));
        this.anchor.set(0.5);
        this.scale.set(2);
    }
}

export class MenuClouds
{
    public view: Container;
    private clouds: MenuCloud[];
    
    private _app: App;
    
    private _w: number = 0;
    
    constructor(app: Application)
    {
        this._app = app as App;
        
        this.view = new Container();
        
        this.clouds = [];
        this.view.sortableChildren = true;
        
        for (let i = 0; i < 10; i++)
        {
            const cloud = new MenuCloud();

            this.view.addChild(cloud);
            this.clouds.push(cloud);
        }
    }
    
    async show(): Promise<void>
    {
        for (let i = 0; i < this.clouds.length; i++)
        {
            const cloud = this.clouds[i];

            cloud.speed = Random.range(0.5, 4);
            cloud.scale.set(1.75 + (cloud.speed * 0.25));
            cloud.x = Random.range(0, this._app.resize.width);
            cloud.y = this._app.resize.height / (this.clouds.length - 1) * i;
            cloud.zIndex = cloud.speed;
        }
    }
    
    update(delta: number): void
    {
        for (const cloud of this.clouds)
        {
            cloud.x -= cloud.speed * delta;
            if (cloud.x < -200) cloud.x = this._w + 200;
        }
    }
    
    resize(w: number, h: number): void
    {
        this._w = w;
    }

}
